module.exports = {
  findOutMoreLink: 'privacy-statement',
  cookiePolicyAcceptanceExpireTime: 365 * 2,
  tutorialViewedExpireTime: 365 * 2,
}
